import { BaseService } from '@services/BaseService'

const resource = 'hr/allergy'

class AllergyService extends BaseService {
  constructor() {
    super(resource)
  }
}

export const allergyService = new AllergyService()
